import yup from '../yup';

export const emailVerificationSchema = yup.object().shape({
  email: yup.string()
    .nullable()
    .required('Please enter your email address')
    .label('email'),
});
